export const formatDraft = (id, results) => {
  const {
    assignmentSheet = null,
    attachments = [],
    formData,
    sheetData = null,
    ...draftFields
  } = results?.draft ?? {};

  return {
    ...draftFields,
    assignmentSheet,
    attachments,
    formData: formData ?? draftFields,
    sheetData,
    draftId: id,
    draftUpdatedAt: results?.updatedAt,
    legacyDraftId: results?.legacyId
  };
};
